import { render, staticRenderFns } from "./RecentRecognition.vue?vue&type=template&id=6dde141e&v-if=isLoggedIn&"
import script from "./RecentRecognition.vue?vue&type=script&lang=js&"
export * from "./RecentRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports